// extracted by mini-css-extract-plugin
module.exports = {"container":"count-down-timer_container__P12u0"};